import { render, staticRenderFns } from "./BMWiProcessExcellenceColumn.vue?vue&type=template&id=6b3a9b53&scoped=true&"
import script from "./BMWiProcessExcellenceColumn.vue?vue&type=script&lang=js&"
export * from "./BMWiProcessExcellenceColumn.vue?vue&type=script&lang=js&"
import style0 from "./BMWiProcessExcellenceColumn.vue?vue&type=style&index=0&id=6b3a9b53&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3a9b53",
  null
  
)

export default component.exports